const getRetriableErrors = state =>
  state.common.errors.filter(error => error.canBeRetried);

export default getRetriableErrors;
